define((require) => {
    "use strict";

    const ExportView            = require("ui/settings/export/ExportView");
    const ExportModel           = require("ui/settings/export/ExportModel");
    const Marionette            = require("marionette");

    /**
     *
     * @class ExportController
     *
     */
    return Marionette.Controller.extend({
        construct: function() {
            let myModel   = new ExportModel();
            this.view     = new ExportView({model: myModel});
        },

        options: {},
        view: ExportView,

        showExport: function() {
            const myModel   = new ExportModel();
            const view      = new ExportView({model: myModel});

            this.options.region.show(view);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/export/ExportController.js